import { render } from "./EditDemandePrixPage.vue?vue&type=template&id=2a5e8abd&ts=true"
import script from "./EditDemandePrixPage.vue?vue&type=script&lang=ts"
export * from "./EditDemandePrixPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__